<div class="list" [style.max-height]="maxHeight" role="list" tabindex="0">
  @for (obj of objects; track trackById($index, obj)) {
    <button
      class="item"
      type="button"
      [attr.aria-label]="obj.title || obj.name"
      role="listitem"
      [title]="obj.title || obj.name"
    >
      <span class="avatar" [style.color]="obj.color || obj.default_color">
        @if (obj.icon) {
          <fa-icon [icon]="obj.icon"></fa-icon>
        } @else {
          {{ initialOf(obj) }}
        }
      </span>
      <span class="title">{{ obj.title || obj.name }}</span>
    </button>
  }

  @if (!objects || objects.length === 0) {
    <div class="empty">
      <span>No items</span>
    </div>
  }
</div>
